module.exports = __webpack_public_path__ + "assets/img/honor1.67108a1d.png";